var infographics_modal = (function( $ ) {

	var init = function() {
		remove_open_modal_class();
		toggle_infographic_display();
	};

	var is_cookie_set = function() {
		return $.cookie( 'emj_gold_infographic_form' ) === 'true';
	};

	var remove_open_modal_class = function() {
		if ( is_cookie_set() ) {
			$( '.open-modal' ).removeClass( 'open-modal' );
		}
	};

	var toggle_infographic_display = function() {
		var elements_to_show = is_cookie_set() ? '#infographics-image, #infographics-link' : '#infographic-blurred-wrapper, #infographics-modal-link';
		var elements_to_hide = is_cookie_set() ? '#infographic-blurred-wrapper, #infographics-modal-link' : '#infographics-image, #infographics-link';

		$( elements_to_show ).css( 'display', 'block' );
		$( elements_to_hide ).css( 'display', 'none' );
		$( '#infographics-link' ).toggleClass( 'active', is_cookie_set() );
	};

	var bind_form_submission_event = function() {
		$( document ).on( 'gform_confirmation_loaded', function( event, form_id ) {
			var gf_form_id = $( '.gravity-form-wrapper' ).data( 'gf-form-id' );

			if ( form_id == gf_form_id ) {
				var hidden_link = $( '#infographics-link' ).clone();
				hidden_link.removeAttr( 'style' );
				$( '.emj-gold-infographic-link.open-modal' ).replaceWith( hidden_link );

				var hidden_image_link = $( '#infographics-pdf-url' ).clone();
				hidden_image_link.removeAttr( 'style' );
				$( '.emj-gold-infographic-image.blurred' ).replaceWith( hidden_image_link );
				$( '#infographic-overlay' ).remove();
			}
		} );
	};

	$( document ).ready( function() {
		init();
		bind_form_submission_event();
	} );

	return {};

})( jQuery );

module.exports = infographics_modal;